import { Component, OnInit, OnDestroy } from '@angular/core';
import { AdminService } from '@app/core/services/admin.service';
//Responsive Options
import { BreakpointObserver } from '@angular/cdk/layout';
//Route Service
import { RouterService } from '@app/core/router/router.service';
//ConfigService
import { ConfigService } from '@app/core/services/config.service';
@Component({
  selector: 'mooc-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit, OnDestroy {

  constructor(
    public service : AdminService,
    private breakpoint : BreakpointObserver,
    private routerService : RouterService,
    private config : ConfigService
  )
  { }

  allCategories = []
  changeImg = false
  responsiveCarousel = false
  responsiveImgCar = false
  grouppedAlies : any[][] = []
  carousel = []

  //Modal No Content
  visible = false

  themeSelected : boolean | undefined
  ngOnInit() {  

    this.service.getCategories().subscribe(res => {
      this.allCategories = res
      console.log('Categorias', this.allCategories)
    })

    this.breakpoint.observe([
      '(max-width : 750px)',
      '(max-width : 810px)',
      '(max-width : 1000px)'
    ]).subscribe(result => {
      if(this.breakpoint.isMatched('(max-width : 700px)')){
        this.responsiveImgCar = true
        this.changeImg = true
      }
      else if(this.breakpoint.isMatched('(max-width : 1090px)')){
        this.responsiveCarousel = true
        this.responsiveImgCar = false
        this.changeImg = true
      }
      else if(this.breakpoint.isMatched('(max-width : 1300px)')){
        this.responsiveCarousel = true
        this.responsiveImgCar = false
      }else if(this.breakpoint.isMatched('(max-width : 1500px)')){
        this.responsiveCarousel = true
        this.responsiveImgCar = false
      }
      else{
        this.responsiveImgCar = false
        this.changeImg = false
        this.responsiveCarousel = false
      }
    })

    if(this.responsiveCarousel){
      this.grouppedAlies = this.chunkArray(this.alies, 4)
    }else{
      this.grouppedAlies = this.chunkArray(this.alies, 4)
    }

    this.startAutoPlay()

    //this.visible = true
  }

  //Modal No Content
  closeModal(){
    this.visible = false
  }

  goRoute(path : string){
    this.routerService.goRoute(path);
  }

  categoryRouter(id : any){
    this.routerService.goRoute('/cursos/escritorio/' + id);
  }

    cardInfoSteps = [
    {
      id : 1,
      title : '1. Inscríbete',
      description : 'Regístrate con tu correo electrónico o tu cuenta de Google y accede al catálogo completo de cursos disponibles.'
    },
    {
      id : 2,
      title : '2. Cursa el MOOC',
      description : 'Desarrolla todos los contenidos, visualiza los vídeos y profundiza con los materiales de apoyo.'
    },
    {
      id : 3,
      title : '3. Certifícate',
      description : 'Evalúa tu conocimiento respondiendo a las actividades y obtén tu certificado de cursado para compartir al aplicar a nuevas oportunidades académicas y laborales.'
    }
  ]

  //Carousel
  currentIndex = 0
  currentIndexMain = 0
  autoMain : any
  autoPlayInterval : any
  alies = [
    {
      id : 1,
      imgUrl : '/assets/mooc/logo/logoNro1.png'
    },
    {
      id : 2,
      imgUrl : '/assets/mooc/logo/logoNro2.png'
    },
    {
      id : 3,
      imgUrl : '/assets/mooc/logo/logoNro3.png'
    },
    {
      id : 4,
      imgUrl : '/assets/mooc/logo/logoNro4.png'
    },
    {
      id : 5,
      imgUrl : '/assets/mooc/logo/logoNro5.png'
    },
    {
      id : 6,
      imgUrl : '/assets/mooc/logo/logoNro6.png'
    },
    {
      id : 7,
      imgUrl : '/assets/mooc/logo/logoNro7.png'
    },
    {
      id : 8,
      imgUrl : '/assets/mooc/logo/logoNro8.png'
    },
    {
      id : 9,
      imgUrl : '/assets/mooc/logo/logoNro9.png'
    },
    {
      id : 10,
      imgUrl : '/assets/mooc/logo/logoNro10.png'
    },
    {
      id : 11,
      imgUrl : '/assets/mooc/logo/logoNro11.png'
    },
    {
      id : 12,
      imgUrl : '/assets/mooc/logo/logoNro12.png'
    },
    {
      id : 13,
      imgUrl : '/assets/mooc/logo/logoNro13.png'
    },
    {
      id : 14,
      imgUrl : '/assets/mooc/logo/logoNro14.png'
    }
  ]

  private chunkArray(array: any[], chunkSize: number): any[][]{
    const result = []
    for(let i = 0; i < array.length; i += chunkSize){
      result.push(array.slice(i, i + chunkSize))
    }

    return result
  }

  next(){
    if(this.grouppedAlies.length > 0){
      this.currentIndex = (this.currentIndex + 1) % this.grouppedAlies.length
    }
  }

  goTo(index : number){
    this.currentIndex = index
  }

  startAutoPlay(){
    this.autoPlayInterval = setInterval(() => {
      this.next()
    }, 5000)
  }

  nextMain(){
    if(this.carousel.length > 0){
      this.currentIndexMain = (this.currentIndexMain + 1) % this.carousel.length
    }
  }

  startAutoMain(){
    this.autoMain = setInterval(() => {
      this.nextMain()
    }, 5000)
  }

  goToMain(index : number){
    this.currentIndexMain = index
  }

  ngOnDestroy(){
    clearInterval(this.autoPlayInterval)
    clearInterval(this.autoMain)
  }
}
